import React from 'react';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  header: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
  },
  title: {
    color: theme.palette.text.secondary,
    fontSize: theme.pxToRem(15),
  },
}));

export type TableTitleClasses = GetClasses<typeof useStyles>;

export interface TableTitleOwnProps {
  centerContent?: React.ReactNode;
  children: any;
  rightContent?: React.ReactNode;
  title: string;
  titleClassName?: string;
  titleActions?: React.ReactNode;
}

export type TableTitleProps = TableTitleOwnProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const TableTitle = (props: TableTitleProps) => {
  const classes = useStyles(props);
  const {
    centerContent,
    children,
    rightContent,
    title,
    titleClassName,
    titleActions,
    ...rootProps
  } = props;
  return (
    <div className={classes.root} {...rootProps}>
      <div className={classes.header}>
        <Box align="center" className={titleClassName}>
          <Text className={classes.title} weight="bold">
            {title}
          </Text>
          {titleActions}
        </Box>
        {centerContent}
        {rightContent}
      </div>
      {children}
    </div>
  );
};

export default React.memo(TableTitle);
